import { EServiceChangeRequestToggleHeaders } from './../../../utils/enums/service-change-request-toggle-header-section.enum';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IIrembogovBasicLabelKeyPair } from '../../models/irembogov-basic-label-keypair.model';

@Component({
  selector: 'irembogov-service-request-header-togger-widget',
  templateUrl: './service-request-header-togger-widget.component.html',
})
export class ServiceRequestHeaderToggerWidgetComponent implements OnInit {
  @Input() selectedOption?: string;
  @Input()
  options: IIrembogovBasicLabelKeyPair<EServiceChangeRequestToggleHeaders>[] =
    [];
  @Input() isColumn = false;

  @Output() selectOption =
    new EventEmitter<EServiceChangeRequestToggleHeaders>();

  buttonColumn!: number;

  ngOnInit(): void {
    this.buttonColumn = this.options.length + 1;
  }
  onSelectOption(value: EServiceChangeRequestToggleHeaders) {
    this.selectOption.emit(value);
  }
}
